import BaseViz from './BaseViz'
import ParallelCoordsChart from '../charts/ParallelCoordsChart'
import ParallelCoordsDataController from '../viz_behaviors/ParallelCoordsDataController'
export default class ParallelCoordsViz extends BaseViz {
  static chartClass = ParallelCoordsChart
  static dataControllerClass = ParallelCoordsDataController
  static defaultConfig = {
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical'],
        nonEditable: true
      },
      colorMode: 'stroke'
    },
    AxisHelper:{
      y: {
        trimThreshold: {
          nonEditable: true
        }
      },
      x: {
        trimThreshold: {
          nonEditable: true
        },
        valueFormat: {
          nonEditable: true
        },
        unit:{
          nonEditable: true
        },
        scale: {
          nonEditable: true
        },
        showTickValues:{
          nonEditable: true
        },
        tickMatchData: {
          nonEditable: true,
          exposed: false
        }
      }
    }
  }
}
